"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemadmin = require("@/api/systemadmin");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  data: function data() {
    return {
      tableData: {},
      tableFrom: {
        page: 1,
        limit: 20
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:log:sensitive:list'])) this.getLogList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getLogList: function getLogList() {
      var _this = this;
      this.listLoading = true;
      (0, _systemadmin.sensitiveListApi)(this.tableFrom).then(function (res) {
        _this.tableData = res;
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getLogList();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getLogList();
    }
  }
};